
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Spinner from "../component/Spinner";
import ConfirmationPopup from '../component/ConfirmationPopup';
import Pagination from '../component/Pagination';
import axiosInstance from "../networking/axiosconfig";
import { IoIosAdd } from "react-icons/io";
import Designationpopup from "../component/Designationpopup";
import Navbar from './Navbar';
import { Monitor, Plus } from 'lucide-react';

const DesignationList = () => {
    const [DesignationList, setDesignationList] = useState([]);
    const [filteredEmployees, setFilteredEmployees] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isPopupVisible, setPopupVisible] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [showDesignationpopup, setShowDesignationpopup] = useState(false);
    const [popupKey, setPopupKey] = useState(0);
    const navigate = useNavigate();

    //  Pagination States
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 15;

    const departmentUrl = `/api/designation`;

    //  Fetch Designation List from API
    useEffect(() => {
        axiosInstance.get(departmentUrl)
            .then((res) => {
                if (res.data && res.data.data) {
                    setDesignationList(res.data.data);
                    setFilteredEmployees(res.data.data);
                } else {
                    console.error('Invalid data format');
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    //  Search Filter
    useEffect(() => {
        const filtered = DesignationList.filter(element =>
            element.designation_name.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredEmployees(filtered);
        setCurrentPage(1);
    }, [searchTerm, DesignationList]);

    //  Pagination Logic
    const totalItems = filteredEmployees.length;
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentDesignationList = filteredEmployees.slice(indexOfFirstItem, indexOfLastItem);


    const handleDeleteClick = (designation_id) => {
        setSelectedId(designation_id);
        setPopupVisible(true);
    };

    const handleConfirmDelete = async () => {
        if (!selectedId) return;
        try {
            await axiosInstance.delete(`/api/designation/${selectedId}`);
            console.log("Designation deleted successfully");
            setPopupVisible(false);
            setDesignationList(prev => prev.filter(item => item.designation_id_PK !== selectedId));
        } catch (error) {
            console.error("Error deleting designation:", error);
        }
    };

    // handle Add buton
    const handleButtonClick = () => {
        setSelectedId(null);
           setPopupKey(prev => prev + 1);
        setShowDesignationpopup(true);
    }



    const handleEditClick = (designation_id_PK) => {
    setShowDesignationpopup(false);

    setTimeout(() => {
        setSelectedId(designation_id_PK);
        setPopupKey(prev => prev + 1);  // ⭐
        setShowDesignationpopup(true);
    }, 0);
};

    return (
          <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
                  <Navbar />
            {/* Confirmation popup */}
            <ConfirmationPopup
                open={isPopupVisible}
                setOpen={setPopupVisible}
                title="Delete"
                message="Are you sure you want to delete?"
                confirmText="Delete"
                onConfirm={handleConfirmDelete}
            />

        

            {showDesignationpopup && (
    <Designationpopup
        key={popupKey}     
        selectedId={selectedId}
        onClose={() => {
            setShowDesignationpopup(false);
            setSelectedId(null);
        }}
    />
)}

            {/* Designation List */}
           <div className="max-w-7xl mx-auto p-6">
        
  <div className="bg-gradient-to-r from-blue-600 via-blue-700 to-indigo-800 rounded-2xl shadow-2xl p-8 mb-6 text-white">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-4">
                            <div className="bg-white bg-opacity-20 p-3 rounded-lg">
                                <Monitor size={32} />
                            </div>
                            <div>
                                <h1 className="text-3xl md:text-4xl font-bold mb-2">Designation List</h1>
                          <h2 className="text-xs md:text-sm ml-1 font-inter ">Welcome to the Designation List.</h2>
                            </div>
                        </div>
                            <button
                                onClick={handleButtonClick}
                                className="flex items-center gap-2 px-6 py-3 bg-white text-blue-600 rounded-lg hover:bg-blue-50 transition-colors font-semibold shadow-lg"
                            >
                                <Plus size={20} />
                                <span>Add Designation</span>
                            </button>
           
                    </div>
                </div>

                {/*  Table Section */}
                <div className="w-full  h-full ">
                    <table className="min-w-full bg-white shadow-md rounded-lg overflow-hidden lg:mt-8 mt-6 ml-1">
                        <thead className="bg-gradient-to-r from-blue-600 via-blue-700 to-indigo-800 rounded-2xl shadow-2xl p-8 mb-6 text-white">
                            <tr>
                                <th className="py-3 px-4 font-inter text-sm text-left font-semibold text-white">S.No.</th>
                                <th className="py-3 px-4 font-inter text-sm text-left font-semibold text-white">Name</th>
                                <th className="py-3 px-4 font-inter text-sm font-semibold text-white">Action</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200">
                            {loading ? (
                                <tr>
                                    <td colSpan="3" className="text-center py-12">
                                        <Spinner size={30} color="#3498db" loading={loading} />
                                    </td>
                                </tr>
                            ) : (
                                currentDesignationList.length > 0 ? (
                                    currentDesignationList.map((element, index) => (
                                        <tr key={element.designation_id_PK} className="border-b hover:bg-gray-50 text-center">
                                            <td className="px-4 py-4 text-left text-sm font-inter">{indexOfFirstItem + index + 1}</td>
                                            <td className="px-4 py-4 text-left text-sm font-inter">{element.designation_name}</td>
                                            <td className="px-4 py-4 text-sm font-inter">
                                                <button
                                                    // onClick={() => navigate(`/designation/edit/${element.designation_id_PK}`)}
                                                    onClick={() => handleEditClick(element.designation_id_PK)}
                                                    className="text-blue-600 hover:text-blue-500 mr-4"
                                                >
                                                    Edit
                                                </button>
                                                <button
                                                    onClick={() => handleDeleteClick(element.designation_id_PK)}
                                                    className="text-red-600 hover:text-red-900"
                                                >
                                                    Delete
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="3" className="text-center py-6 text-gray-500">No results found.</td>
                                    </tr>
                                )
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/*  Fixed Pagination at Bottom */}
  <div className="max-w-7xl mx-auto">
                <div className="w-full bg-white rounded-2xl ">
                <Pagination
                    totalItems={totalItems}
                    itemsPerPage={itemsPerPage}
                    currentPage={currentPage}
                    onPageChange={setCurrentPage}
                />
                </div>
            </div>
        </div>
    );
};

export default DesignationList;
